import { useContext } from "react";
import { DependenciesContext } from "../providers/DependenciesProvider";
import { Apis } from "../../network/apis";

export function useKairosApi(): Apis | undefined {
  return useContext(DependenciesContext)?.apis;
}
